import { NgComponentOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { tracking } from '@ecs-helpers';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TrackingService } from '@os-components';
import { SewHeadline, SewTabBar, SewTabBarItem } from '@sew/ui-components-angular/standalone';
import { GearOilComponent } from '../gear-oil-component/gear-oil.component';
import { RequestServiceComponent } from '../request-service/request-service.component';
import { SuppliesServicesTab, SupplyService } from './supplies-services.types';

@Component({
    selector: 'ecs-supplies-services',
    templateUrl: './supplies-services.component.html',
    styleUrls: ['./supplies-services.component.scss'],
    imports: [SewHeadline, SewTabBar, SewTabBarItem, TranslateDirective, NgComponentOutlet, TranslatePipe],
})
export class SuppliesServicesComponent {
    @Input() public activeTab?: number;

    @Input() public availableTabs?: SuppliesServicesTab[] | undefined;

    public constructor(private trackingService: TrackingService) {}

    public tabSelected(component: SupplyService, index: number) {
        this.activeTab = index;
        switch (component) {
            case GearOilComponent:
                this.trackingService.trackEvent(tracking.step.accessoriesAndServices.gearOil.tab);
                break;
            case RequestServiceComponent:
                this.trackingService.trackEvent(tracking.step.accessoriesAndServices.service.tab);
                break;
            default:
                // nothing to do
                break;
        }
    }
}
